import { intercept, observable } from 'mobx';
import { Store } from 'bernie-plugin-mobx';

import { SerializedData } from 'bernie-core';

export class ChildModel extends Store {
  constructor(state: SerializedData = {}) {
    super({}, null);

    intercept(this, 'age', change => {
      const value = parseInt(change.newValue, 10);

      if (isNaN(value) || value < 0) {
        change.newValue = 0;
      } else {
        change.newValue = value;
      }

      return change;
    });

    if (typeof state === 'object' && state !== null) {
      this.age = state.age;
    }
  }

  public static DEFAULTS: any = {
    age: 0,
  };

  @observable
  public age: number;

  public clone(): ChildModel {
    return new ChildModel(this.toJSON());
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
